<template lang="pug">
div
  #userapprove
    .title 审批意见
    el-input(v-model="comment", maxlength="200", show-word-limit, type="textarea")
    el-button.approveUpload(icon="el-icon-upload2", type="text", @click="choiceFile") 上传审批附件
    .file-list
      .file-label(v-for="(file, index) in fileList", :key="file.fileId", :title="file.fileName")
        img(:src="className(file)")
        .fileName(@click="preview(file)") {{ file.fileName }}
        .btnRight
          i.el-icon-download(title="下载", @click.stop="downLoadFile(file)")
          i.el-icon-delete(@click.stop="deleteFile(file)")
    .operButton
      el-button(type="primary", size="small", @click="transfer") 转交
      el-button(type="danger", size="small", @click="rejectNodeFlow") 驳回
      el-button(type="success", size="small", @click="agree") 同意
</template>

<script>
import flowService from "@/CommonDP/service/flow-service";
import { getApprove } from "@/CommonDP/components/processComponents/flowNewConfig/mapStore.js";
import { openMember, openH5Member } from "@/CommonDP/components/chooseMember/leftCom.js";
import { Notify } from "vant";
import { tableRowIcon, filePreviewV1 } from "@/CommonDP/utils/docPublic";
import { downloadUrltoken, downloadFile, wrapCallBack } from "@/CommonDP/utils/index";
import { uploader } from "@/CommonDP/utils/IUploader/dp";

export default {
  components: {},
  props: {
    getBasicData: { type: Function, default: null },
    uuid: { type: String, default: "" },
    source: { type: String, default: "pc" }
  },
  data() {
    return {
      comment: "",
      fileList: []
    };
  },
  computed: {
    nodeList() {
      return getApprove(this.uuid)?.getFlowNodeDtoList();
    },
    prjId() {
      return getApprove(this.uuid)?.getPrjId();
    },
    flowInstanceId() {
      return getApprove(this.uuid).getMessage()?.flowInstanceId || "";
    },
    currentNode() {
      // nodeStatus:0：拒绝 1：同意 2：审批中 3：发起 4：再发起 5：撤销
      return this.nodeList.find((e) => e.nodeStatus === "2");
    },
    flowNodeId() {
      return this.currentNode.flowNodeId;
    },
    nowflowNodeDefinitionId() {
      return this.currentNode?.flowNodeDefinitionId;
    },
    // 下个节点的id 没有默认为0
    flowNextNodeId() {
      const index = this.nodeList.findIndex((e) => e.nodeStatus === "2");
      return this.nodeList[index + 1]?.flowNodeDefinitionId || 0;
    },
    // 下个节点是否允许增加审批人
    allowAddApproverDynamic() {
      const index = this.nodeList.findIndex((e) => e.nodeStatus === "2");
      return this.nodeList[index + 1]?.allowAddApproverDynamic || 0;
    },
    // 下个节点的审批人
    nextNodeAssigneeList() {
      return this.nodeList.find((e) => e.flowNodeDefinitionId === this.flowNextNodeId)?.assigneeList;
    },
    nextNodeCCList() {
      return this.nodeList.find((e) => e.flowNodeDefinitionId === this.flowNextNodeId)?.ccList;
    },
    // 当前节点的抄送人
    nowNodeCCList() {
      return this.nodeList.find((e) => e.flowNodeDefinitionId === this.nowflowNodeDefinitionId)?.ccList || [];
    },
    userDtoList() {
      const assigneeList = this.nextNodeAssigneeList.map((e) => {
        return { ...e, type: 0 };
      });
      const ccList = this.nextNodeCCList.map((e) => {
        return { ...e, type: 1 };
      });
      return [...assigneeList, ...ccList];
    },
    nextNodeAssignee() {
      return {
        flowNodeDefinitionId: this.flowNextNodeId,
        userDtoList: this.userDtoList
      };
    },
    fileIds() {
      return this.fileList.map((e) => e.fileId) || [];
    }
  },
  methods: {
    async waitFlowSubmit(params, flag) {
      const flow = getApprove(this.uuid);
      const fn = flow?.vform?.handleOnFlowSubmit;
      return wrapCallBack(fn, { node: this.currentNode, params, flag });
    },
    async transfer() {
      const props = {
        filterOneself: false,
        codePri: ["User"],
        usersList: [],
        max: 1
      };
      const val = this.source !== "h5" ? await openMember(props) : await openH5Member(props);
      const params = {
        flowInstanceNodeId: this.flowNodeId,
        transferId: val[0].userId
      };
      const cb = await this.waitFlowSubmit(params, 'transfer');
      await flowService.transfer(params);
      this.$emit("closeDialog");
      if (this.source !== "h5") {
        this.$success("转交成功");
      } else {
        Notify({ type: "success", message: "转交成功" });
      }
      await cb();
    },
    async agree() {
      // 下个节点允许增加审批人
      if (this.allowAddApproverDynamic === 1) {
        if (this.nextNodeAssigneeList && this.nextNodeAssigneeList.length === 0) {
          this.$message.warning("请先选择下个节点的审批人");
          return;
        }
      }
      const requestUrl = this.getBasicData();
      Promise.resolve(requestUrl).catch((error) => {
        this.$message.warning(error || "请填写完整表单");
      });
      const json = await requestUrl;
      const params = {
        comment: this.comment,
        fileIds: this.fileIds,
        flowInstanceNodeId: this.flowNodeId,
        json,
        nextNodeAssignee: this.allowAddApproverDynamic === 1 ? this.nextNodeAssignee : {},
        ccList: this.nowNodeCCList
      };
      await this.$confirm(`确认同意吗?`, {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      });
      const cb = await this.waitFlowSubmit(params, 'agree');
      await flowService.agree(params);
      if (this.source !== "h5") {
        this.$success("操作成功");
      } else {
        Notify({ type: "success", message: "操作成功" });
      }
      await cb();
      this.$emit("closeDialog");
    },
    async rejectNodeFlow() {
      if (!this.comment) {
        return this.$message.error("驳回意见不能为空");
      }
      await this.$confirm("此操作将流程驳回至发起人，发起人再次提交后方能继续。确认驳回吗?", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      });
      const json = await this.getBasicData(false);
      const params = {
        comment: this.comment,
        fileIds: this.fileIds,
        flowInstanceNodeId: this.flowNodeId,
        json,
        name: "",
        transferId: ""
      };
      const cb = await this.waitFlowSubmit(params, 'reject');
      await flowService.rejectNodeFlow(params);
      if (this.source !== "h5") {
        this.$success("操作成功");
      } else {
        Notify({ type: "success", message: "请求成功" });
      }
      await cb();
      this.$emit("closeDialog");
    },
    async choiceFile() {
      const params = this.prjId ? { prjId: this.prjId } : {};
      await uploader.getHiddenParams(params);
      const list = await uploader.open({ params, showPanel: true, once: false });
      list.forEach(this.fileAdded);
    },
    fileAdded(val) {
      if (val && val.fileId) {
        this.fileList.push(val);
      } else {
        this.fileList = [];
      }
    },
    deleteFile(file) {
      this.fileList = this.fileList.filter((item) => item.fileId !== file.fileId);
    },
    className(row) {
      return tableRowIcon(row);
    },
    preview(file) {
      const data = {
        fileType: file.fileType,
        fileId: file.fileId,
        versionId: file.versionIds || file.fileVersion,
        flowInstanceId: this.flowInstanceId,
        status: file.status,
        parentId: file.parentId
      };
      filePreviewV1(data, this.fileList);
    },
    downLoadFile(row) {
      const fileId = row.fileId;
      const url = downloadUrltoken("EnterpriseDoc", fileId);
      downloadFile(url);
    }
  }
};
</script>

<style lang="scss" scoped>
.title {
  line-height: 40px;
  font-size: 14px;
  display: flex;
  flex-direction: row;
  align-items: center;
}
.approveUpload {
  cursor: pointer;
  color: #5584ff;
  font-size: 14px;
}
.operButton {
  height: 50px;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
}
.file-list {
  max-height: 80px;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  .file-label {
    border-radius: 6px;
    padding: 0 6px;
    height: 40px;
    min-height: 40px;
    display: flex;
    flex-direction: row;
    align-items: center;
  }
  img {
    width: 20px;
    height: 20px;
    margin-right: 5px;
  }
  .fileName {
    cursor: pointer;
    overflow-x: auto;
  }
  .btnRight {
    margin-left: auto;
    i {
      font-size: 14px;
    }
    .el-icon-download {
      color: #5584ff;
      margin-right: 10px;
      cursor: pointer;
    }
    .el-icon-delete {
      color: #f54f45;
      cursor: pointer;
    }
  }
  .file-label:hover {
    background-color: rgba(#409eff, 0.2);
  }
}
</style>
